export const OA = {
    API: 'OA'
}

export const OAAPIConstant = {
    getByCAI: OA.API + '/GetByCAI', // Get OA by CAI (right table data)
    getAll : OA.API + '/GetAll', // Get all OA (left table data)
    getTagDetails   : OA.API + '/Details', // Get tag details
    getWorkOrderList: OA.API + '/GetWorkOrderNo', // Get work order list
    updateOA : OA.API + '/UpdateOA', // Update OA
    saveOA : OA.API + '/SaveOA', // Update tag
}